'use client'

import '../../sass/menu/LanguageFlag.scss'
import { Language } from '@/lib/interfaces/interfaces'
import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'
import { useSearchParams } from 'next/navigation'

interface Props {
  slug: string
  language: Language
}

const LanguageFlag = ({ slug, language }: Props) => {
  const searchParams = useSearchParams()
  const isDelivery = searchParams.get('order') === 'delivery'

  let defaultEnglishFlag = '/img/flags/us-flag.svg'

  if (typeof window !== 'undefined') {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (timeZone.includes('Europe')) {
      defaultEnglishFlag = '/img/flags/en-flag.svg' // Bandera de Reino Unido
    }
  }

  const [englishFlag] = useState(defaultEnglishFlag)

  const otherLanguages = (['en', 'es', 'fr'] as Language[]).filter(
    lang => lang !== language
  )

  const getFlagSrc = (lang: Language) => {
    if (lang === 'en') {
      return englishFlag
    }
    return `/img/flags/${lang}-flag.svg`
  }

  return (
    <div className='language-flag'>
      {otherLanguages.map(lang => (
        <Link
          prefetch={false}
          key={lang}
          href={`/menu/${slug}/${lang}${isDelivery ? '?order=delivery' : ''}`}
        >
          <Image
            className='flag'
            src={getFlagSrc(lang)}
            width={180}
            height={60}
            alt={`imagen de idioma ${lang}`}
          />
        </Link>
      ))}
    </div>
  )
}

export default LanguageFlag
